// Persistence for the chat/alert log message type filters. Shared by the classic dashboard,
// the editable dashboard panels and the filter dropdown so a log and its filter button always
// start out in sync, and the choice survives a reload.

const STORAGE_PREFIX = 'logMessageTypeFilter:';

const DEFAULT_HIDDEN = {
	chat: [],
	alerts: [],
};

// Types the chat filter never offers: a chat log without chat messages is pointless, and the
// two moderation events are how the log explains messages disappearing from it.
export const ALWAYS_VISIBLE_TYPES = [ 'chat', 'clear', 'delete' ];

// Comings and goings never reach the chat log at all - they run through its own events bar
// above the input instead - so the chat filter has nothing to offer for them either. The
// alert log still lists the ones that are alert types (like, share) in its own filter.
export const EVENT_BAR_TYPES = [ 'like', 'join', 'leave', 'share' ];

// Types a log's filter has no control over, and so must never keep in its hidden set.
export function getUnfilterableMessageTypes(mode) {
	return mode == 'alerts' ? [] : [ ...ALWAYS_VISIBLE_TYPES, ...EVENT_BAR_TYPES ];
}

// mode is 'chat' or 'alerts' - each log keeps its own set of hidden event types.
export function getDefaultHiddenMessageTypes(mode) {
	return [ ...(DEFAULT_HIDDEN[mode] || []) ];
}

export function loadHiddenMessageTypes(mode) {
	try {
		const saved = JSON.parse(localStorage.getItem(`${STORAGE_PREFIX}${mode}`));
		// Drop types the filter doesn't offer, in case they were saved before they stopped
		// being offered - otherwise the gear would read as filtered with nothing to unset.
		const unfilterable = getUnfilterableMessageTypes(mode);
		if(Array.isArray(saved)) return saved.filter(t => typeof t == 'string' && !unfilterable.includes(t));
	} catch(e) {
		// malformed state, fall through to the default
	}
	return getDefaultHiddenMessageTypes(mode);
}

export function saveHiddenMessageTypes(mode, hidden) {
	try {
		localStorage.setItem(`${STORAGE_PREFIX}${mode}`, JSON.stringify(hidden || []));
	} catch(e) {
		console.error(e);
	}
}
